const layout = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M13.5 2.5v11h-11v-11zM15 1H1v14h14z"/><path d="M6.75 6.75V14h-1.5V6.75H2v-1.5h12v1.5z"/></svg>',
};

export { layout as default };
